import { call, put, takeLatest } from "redux-saga/effects";
import { onPostSendSmsError, onPostSendSmsSubmit, onPostSendSmsSuccess } from "../Store/Slices/sendSmsSlice";
import { callSendSmsApi } from "../Context/sendSMSApi";

function* PostSendSms({ payload }) {
  try {
    const postSendSmsResponse = yield call(callSendSmsApi, payload);
    if (postSendSmsResponse.responseCode === "200") {
      yield put(
        onPostSendSmsSuccess({
          postData: postSendSmsResponse.response,
          message: postSendSmsResponse.responseMessage,
          status_code: postSendSmsResponse.responseCode,
        })
      );
    } else {
      yield put(
        onPostSendSmsError({
          data: postSendSmsResponse.response,
          message: postSendSmsResponse.responseMessage,
          status_code:postSendSmsResponse.responseCode
        })
      );
    }
  } catch (error) {
    const message = error.response.data.responseMessage  || "Something went wrong";
    yield put(onPostSendSmsError({ data: [], message, status_code: 400 }));
  }
}
export default function* sendSmsSaga() {
  yield takeLatest(onPostSendSmsSubmit.type, PostSendSms);
}
